module.exports = __webpack_public_path__ + "img/icon_instagram_rotate.2b6f59f8.svg";